import { iaRa } from 'lib/helpers/utility';
import { getProcedureName } from 'lib/helpers/getProcedureName';

// Services read "Code - name" (name alone when the service has no code); procedure-code lists show
// only codes. Strings pass through so already-formatted lists render as-is.
export const formatProcedure = (procedure, isCodesOnly = false) => {
  if (typeof procedure === 'string') return procedure;
  return isCodesOnly ? procedure?.procedure_code : getProcedureName(procedure);
};

export const formatProcedures = (procedures, isCodesOnly = false) =>
  iaRa(procedures)
    .map((procedure) => formatProcedure(procedure, isCodesOnly))
    .filter(Boolean);

// Appointment rows: older API responses carry only a pre-built `procedures_label` summary.
export const getServiceLabels = (invoice) => {
  const labels = formatProcedures(invoice?.procedures);
  if (labels.length) return labels;
  return invoice?.procedures_label ? [invoice.procedures_label] : [];
};
